import Api from "@/api/Api";
//import axios from 'axios';
import errorHandler from "@/utils/plugins/ErrorHandler";

const RESOURCE_NAME = "/api/vehicle_requests";

export default {
  // VEHICLES
  getVehicleRequests(params) {
    return Api()
      .get(RESOURCE_NAME, { params: params })
      .catch((err) => errorHandler(err, null));
  },
  getVehicleRequest(id) {
    return Api()
      .get(RESOURCE_NAME + `/${id}`)
      .catch((err) => errorHandler(err, null));
  },
  createVehicleRequest(item) {
    return Api()
      .post(RESOURCE_NAME, item)
      .catch((err) => errorHandler(err, null));
  },
  updateVehicleRequest(id, item) {
    return Api()
      .put(RESOURCE_NAME + `/${id}`, item)
      .catch((err) => errorHandler(err, null));
  },
  deleteVehicleRequest(id) {
    return Api()
      .delete(RESOURCE_NAME + `/${id}`)
      .catch((err) => errorHandler(err, null));
  },
  approveVehicleRequest(id) {
    return Api()
      .post(RESOURCE_NAME + `/${id}/approve`)
      .catch((err) => errorHandler(err, null));
  },
  cancelVehicleRequest(id, item) {
    return Api()
      .post(RESOURCE_NAME + `/${id}/cancel`, item)
      .catch((err) => errorHandler(err, null));
  },
  returnVehicleRequest(id, item) {
    return Api()
      .post(RESOURCE_NAME + `/${id}/return`, item)
      .catch((err) => errorHandler(err, null));
  },
  rejectVehicleRequest(id, item) {
    return Api()
      .post(RESOURCE_NAME + `/${id}/reject`, item)
      .catch((err) => errorHandler(err, null));
  },
  confirmVehicleRequest(id, item) {
    return Api()
      .post(RESOURCE_NAME + `/${id}/confirm`, item)
      .catch((err) => errorHandler(err, null));
  },
    correctVehicleRequest(id, item) {
    return Api()
      .put(RESOURCE_NAME + `/${id}/correct`, item)
      .catch((err) => errorHandler(err, null));
  },
};
